import React, { useState } from 'react';
import FollowersList from './FollowersList';
import FollowingList from './FollowingList';
import './UserFollowStats.css';

const UserFollowStats = ({ userId, followersCount, followingCount }) => {
  const [showFollowers, setShowFollowers] = useState(false);
  const [showFollowing, setShowFollowing] = useState(false);

  return (
    <>
      <div className="user-follow-stats">
        <button 
          className="follow-stat-item"
          onClick={() => setShowFollowers(true)}
        >
          <span className="follow-stat-count">{followersCount || 0}</span>
          <span className="follow-stat-label">Followers</span>
        </button>
        <button 
          className="follow-stat-item"
          onClick={() => setShowFollowing(true)}
        >
          <span className="follow-stat-count">{followingCount || 0}</span>
          <span className="follow-stat-label">Following</span>
        </button>
      </div>

      {showFollowers && (
        <FollowersList
          userId={userId}
          onClose={() => setShowFollowers(false)}
        />
      )}

      {showFollowing && (
        <FollowingList
          userId={userId}
          onClose={() => setShowFollowing(false)}
        />
      )}
    </>
  );
};

export default UserFollowStats;

